import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Spinner from '../Spinner';
import loadWorldpayLibrary from './loadWorldpayLibrary';

import messages from './WorldpayIframe.messages';

class WorldpayIframe extends Component {
  state = { ready: false };

  ref = null;

  componentDidMount() {
    loadWorldpayLibrary().then((WPCL) => {
      // Note: This needs to be a global object, See https://payments.worldpay.com/resources/hpp/integrations/embedded/doc/
      global.wpLibraryObject = new WPCL.Library();
      global.wpLibraryObject.setup({
        type: 'iframe',
        iframeIntegrationId: 'wpLibraryObject',
        target: 'worldpay-iframe-container',
        accessibility: true,
        inject: 'immediate',
        resultCallback: this.props.onResult,
        url: this.props.url,
        iframeHelperURL: this.props.iframeHelperURL,
        iframeBaseURL: this.props.iframeBaseURL,
      });

      const iframe = this.ref.querySelector('iframe');

      iframe.addEventListener('load', () => this.iframeDidLoad(iframe));
    });
  }

  iframeDidLoad(iframe) {
    this.setState(() => ({ ready: true }));
    const width = Math.min(760, Math.max(300, window.innerWidth));
    iframe.setAttribute('width', width);
    iframe.setAttribute('style', `width:${width}px`);
  }

  render() {
    const containerClasses = {
      'dn': !this.state.ready,
      'bg-white': true,
    };

    return (
      <Fragment>
        <div className={this.state.ready ? 'dn' : ''}>
          <Spinner />
        </div>
        <div
          id="checkout-modal-container"
          className={classnames(containerClasses)}
        >
          <div className="pa4">
            <div className="b f4 mb2">
              <FormattedMessage {...messages.total} />
            </div>
            <div>{this.props.grandTotal}</div>
          </div>

          <div
            id="worldpay-iframe-container"
            ref={(ref) => {
              this.ref = ref;
            }}
          />
        </div>
      </Fragment>
    );
  }
}

WorldpayIframe.defaultProps = {
  onResult: () => {},
  iframeHelperURL: null,
  iframeBaseURL: null,
};

WorldpayIframe.propTypes = {
  onResult: PropTypes.func,
  url: PropTypes.string.isRequired,
  iframeHelperURL: PropTypes.string,
  iframeBaseURL: PropTypes.string,
  grandTotal: PropTypes.string.isRequired,
};

export default WorldpayIframe;
